import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { DownloadIcon } from '@/components/elements/Icon/Download'
import { ExternalLinkIcon } from '@/components/elements/Icon/ExternalLink'

type Props = {
  url: string
  fileType: string
}

export const DownloadLink = ({ fileType, url }: Props) => {
  if (fileType === 'application/pdf') {
    return (
      <Anchor href={url} target="_blank">
        <ExternalLinkIcon />
        <Text>PDF</Text>
      </Anchor>
    )
  }

  if (fileType === 'application/zip') {
    return (
      <Anchor href={url}>
        <DownloadIcon />
        <Text>ZIP</Text>
      </Anchor>
    )
  }

  return null
}

const Anchor = styled.a`
  width: 236px;
  height: 50px;
  background-color: #fff;
  border: 1px solid ${theme.colors.trialBlue};
  color: ${theme.colors.trialBlue};
  border-radius: 29px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 24px;
  cursor: pointer;
  transition: all 0.3s ease-out;

  &:hover {
    background-color: ${theme.colors.hover};
    border-color: ${theme.colors.hover};
    color: #ffffff;

    > svg {
      fill: #ffffff;
    }
  }

  @media screen and (max-width: 1047px) {
    height: 36px;
    padding-left: 17px;
    gap: 8px;
  }
`

const Text = styled.span`
  font-size: 18px;
  line-height: 26px;

  @media screen and (max-width: 1047px) {
    font-size: 14px;
    line-height: 20px;
    padding-left: 7px;
  }
`
